var messages = {
  placeholder: '入力して下さい',
  passwordPlaceholder: 'パスワードを入力'
};
export default messages;